import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { Field } from "@/components/admin/kit";
import { useTerms } from "@/lib/industry";

const DAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
const ZONES = [["America/Vancouver", "Pacific"], ["America/Edmonton", "Mountain"], ["America/Regina", "Saskatchewan"], ["America/Winnipeg", "Central"], ["America/Toronto", "Eastern"], ["America/Halifax", "Atlantic"], ["America/St_Johns", "Newfoundland"]];
export const BOOKING_DEFAULT = { enabled: true, days: [0, 1, 2, 3, 4, 5, 6], start: "11:00", end: "17:00", slot_minutes: 75, timezone: "America/Edmonton", days_ahead: 60 };

export function BookingHours({ value, onChange }) {
  const v = { ...BOOKING_DEFAULT, ...(value || {}) };
  const { t, sells } = useTerms();
  const set = (k, x) => onChange({ ...v, [k]: x });
  const toggleDay = (i) => set("days", v.days.includes(i) ? v.days.filter((d) => d !== i) : [...v.days, i].sort());
  return (
    <div className="sm:col-span-2 rounded-2xl bg-slate-50 border p-4 space-y-4" data-testid="booking-settings">
      <label className="flex items-start gap-3 text-sm">
        <Switch checked={v.enabled} onCheckedChange={(x) => set("enabled", x)} data-testid="booking-enabled-toggle" />
        <span><strong>{sells ? "Online viewing calendar" : "Online booking calendar"}</strong><br /><span className="text-slate-500">{t.Who} pick a free time slot and it's confirmed straight away. You and they both get an email. Booked slots disappear for everyone else. Turn off to go back to "request a time".</span></span>
      </label>
      {v.enabled && (
        <>
          <div>
            <p className="text-xs uppercase tracking-widest text-slate-500 mb-2">Open days</p>
            <div className="flex flex-wrap gap-2">
              {DAYS.map((d, i) => <button type="button" key={d} onClick={() => toggleDay(i)} className={`h-9 w-14 rounded-full border text-sm ${v.days.includes(i) ? "bg-slate-900 text-white" : "bg-white text-slate-500"}`} data-testid={`booking-day-${i}`}>{d}</button>)}
            </div>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-5 gap-3">
            <Field label="Opens"><Input type="time" value={v.start} onChange={(e) => set("start", e.target.value)} data-testid="booking-start" /></Field>
            <Field label="Closes"><Input type="time" value={v.end} onChange={(e) => set("end", e.target.value)} data-testid="booking-end" /></Field>
            <Field label="Slot length">
              <select value={v.slot_minutes} onChange={(e) => set("slot_minutes", +e.target.value)} className="h-10 w-full rounded-md border px-2 text-sm bg-white" data-testid="booking-slot-length">
                {[30, 45, 60, 75, 90, 120].map((m) => <option key={m} value={m}>{m} min</option>)}
              </select>
            </Field>
            <Field label="Time zone">
              <select value={v.timezone} onChange={(e) => set("timezone", e.target.value)} className="h-10 w-full rounded-md border px-2 text-sm bg-white" data-testid="booking-timezone">
                {ZONES.map(([z, l]) => <option key={z} value={z}>{l}</option>)}
              </select>
            </Field>
            <Field label="Book up to (days ahead)"><Input type="number" min={1} max={365} value={v.days_ahead} onChange={(e) => set("days_ahead", +e.target.value || 1)} data-testid="booking-days-ahead" /></Field>
          </div>
        </>
      )}
    </div>
  );
}
